
// const BASE_URL = "http://192.168.1.13:3000";

import { MonsterDto, SourceDto, SpellDto } from "../Types/ApiTypes";

// const BASE_URL = "https://www.dnd5eapi.co"; 
const BASE_URL = "https://dndbackend.jpriz.duckdns.org";
// const BASE_URL = "http://localhost:8080"
export async function getAllSpells() {
  const spellIndexes = await fetch(BASE_URL + "/spells").then((response) =>
    response.json()
  );
  return spellIndexes;
}

export async function getSpellByIndex(index: string) {
  const spell = await fetch(BASE_URL + "/spells/"+index).then((response) =>
    response.json()
  );
  return spell;
}

export async function getSpell(id: number) {
  const spell = await fetch(BASE_URL + "/spells/"+id).then((response) =>
    response.json()
  );
  return spell;
}


export async function addSpell(spell: SpellDto) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(spell)
  };
  const spellResult = await fetch(BASE_URL + "/spells/", requestOptions).then((response) =>
    response.json()
  );
  return spellResult;
}

export async function putSpell(spell: SpellDto) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(spell)
  };
  const spellResult = await fetch(BASE_URL + "/spells/", requestOptions).then((response) =>
    response.json()
  );
  return spellResult;
}

export async function deleteSpell(id: number) {
  const requestOptions = {
    method: 'DELETE',
  };
  const spellResult = await fetch(BASE_URL + "/spells/"+id, requestOptions).then((response) =>
    response.status
  );
  return spellResult;
}



export async function getAllSources() {
  const spellIndexes = await fetch(BASE_URL + "/sources").then((response) =>
    response.json()
  );
  return spellIndexes;
}

export async function getSource(id: number) {
  const spell = await fetch(BASE_URL + "/sources/"+id).then((response) =>
    response.json()
  );
  return spell;
}

export async function addSource(source: SourceDto) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(source)
  };
  const sourceResult = await fetch(BASE_URL + "/sources/", requestOptions).then((response) =>
    response.json()
  );
  return sourceResult;
}

export async function putSource(source: SourceDto) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(source)
  };
  const sourceResult = await fetch(BASE_URL + "/sources/", requestOptions).then((response) =>
    response.json()
  );
  return sourceResult;
}

export async function deleteSource(id: number) {
  const requestOptions = {
    method: 'DELETE',
  };
  const sourceResult = await fetch(BASE_URL + "/sources/"+id, requestOptions).then((response) =>
    response.status
  );
  return sourceResult;
}


export async function getAllMonsters() {
  const spellIndexes = await fetch(BASE_URL + "/monsters").then((response) =>
    response.json()
  );
  return spellIndexes;
}

export async function getMonster(id: number) {
  const spell = await fetch(BASE_URL + "/monsters/"+id).then((response) =>
    response.json()
  );
  return spell;
}

export async function addMonster(monster: MonsterDto) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(monster)
  };
  const monsterResult = await fetch(BASE_URL + "/monsters/", requestOptions).then((response) =>
    response.json()
  );
  return monsterResult;
}

export async function putMonster(monster: MonsterDto) {
  const requestOptions = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(monster)
  };
  const monsterResult = await fetch(BASE_URL + "/monsters/", requestOptions).then((response) =>
    response.json()
  );
  return monsterResult;
}

export async function deleteMonster(id: number) {
  const requestOptions = {
    method: 'DELETE',
  };
  const monsterResult = await fetch(BASE_URL + "/monsters/"+id, requestOptions).then((response) =>
    response.status
  );
  return monsterResult;
}